<div class="main-container">
  <div class="user-selection-container">
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          <mat-icon>add_circle_outline</mat-icon>
          Add User
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="expansion-content">
        <div class="user-search">
          <mat-form-field>
            <mat-label>User Email Address</mat-label>
            <input
              matInput
              type="text"
              [(ngModel)]="userEmail"
              required
            />
          </mat-form-field>
        </div>
        <button
          mat-raised-button
          *ngIf="validateWarn === false"
          color="primary"
          (click)="validateUser()"
        >
          Validate
        </button>
        <button mat-raised-button *ngIf="validateWarn === true" color="warn">
          Not A Valid User
        </button>
        <div class="user-search">
          <mat-form-field>
            <mat-label>Group Name</mat-label>
            <mat-select
              (selectionChange)="selectGroupName($event)"
              [(ngModel)]="selectedGroupName"
              [disabled]="!userIsValid"
            >
              <mat-option
                *ngFor="let group of groups"
                value="{{ group.groupName }}"
              >
                {{ group.groupName }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <button
          mat-raised-button
          color="accent"
          [disabled]="canAddUser"
          (click)="addUser()"
        >
          Add User
        </button>
        <div *ngIf="userAdded === true" class="user-added">
          <mat-icon style="margin-left: 1rem" color="accent"
            >done_outline</mat-icon
          >
          <p>User Added!</p>
        </div>
      </div>
    </mat-expansion-panel>
  </div>
  <mat-progress-bar
    *ngIf="isLoading === true"
    mode="indeterminate"
    color="accent"
  ></mat-progress-bar>
  <mat-divider class="section-divide"></mat-divider>
  <div class="table-container">
    <div class="table-search">
      <mat-form-field>
        <mat-label>Search Users</mat-label>
        <input
          matInput
          (keyup)="applyFilter($event.target.value)"
        />
      </mat-form-field>
    </div>
    <div class="table mat-elevation-z8" *ngIf="showTable === true">
      <table mat-table [dataSource]="dataSource">
        <ng-container matColumnDef="user">
          <th mat-header-cell *matHeaderCellDef><h5>User</h5></th>
          <td mat-cell *matCellDef="let user">{{ user.email }}</td>
        </ng-container>
        <ng-container matColumnDef="reportsTo">
          <th mat-header-cell *matHeaderCellDef><h5>Report To</h5></th>
          <td mat-cell *matCellDef="let user">{{ user.reportsTo }}</td>
        </ng-container>
        <ng-container matColumnDef="groupName">
          <th mat-header-cell *matHeaderCellDef><h5>Group Name</h5></th>
          <td mat-cell *matCellDef="let user; let i = index">
            <div
              *ngIf="
                (!isEdit && userIndex !== i) || (isEdit && userIndex !== i)
              "
              class="static-groupName"
            >
              {{ user.groupName }}
              <button
                mat-icon-button
                color="primary"
                (click)="editUser(i, user.groupName)"
              >
                <mat-icon>edit</mat-icon>
              </button>
            </div>
            <div *ngIf="isEdit === true && userIndex === i">
              <mat-form-field>
                <mat-label>{{ user.groupName }}</mat-label>
                <mat-select
                  #mySelect
                  (selectionChange)="editGroup($event)"
                >
                  <mat-option
                    *ngFor="let group of groups"
                    value="{{ group.groupName }}"
                  >
                    {{ group.groupName }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
              <button mat-icon-button color="primary" (click)="closeEdit(user)">
                <mat-icon>save_alt</mat-icon>
              </button>
            </div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
      <mat-paginator
        [length]="usersLength"
        [pageSize]="25"
        [pageSizeOptions]="[10, 25, 50, 100]"
      >
      </mat-paginator>
    </div>
  </div>
</div>
